export const localStorageKeys = {
  formName: 'formName',
  primaryLanguage: 'primaryLanguage',
  sectionsCount: 'sectionsCount',
  additionalLanguages: 'additionalLanguages',
  configurationProperties: 'configurationProperties',
  formData: 'formData',
  theme: 'theme',
}
